import { isEmpty } from "lodash";

const ValidationErrorMessage = ({ message }) => {
  if (isEmpty(message)) return null;

  return <p className="text-red-600 text-sm pb-1.5">{message}</p>;
};

export default ValidationErrorMessage;
